import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ConfigureWebsite from "./routes/ConfigureWebsite";

export default store => ({
  path: "manage-websites",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "manage-websites" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [ConfigureWebsite(store)],
});
